import de from './de.translations.json.js';
import en from './en.translations.json.js';
import es from './es.translations.json.js';
import fr from './fr.translations.json.js';
import it from './it.translations.json.js';
import nl from './nl.translations.json.js';
import searchSuggesterTranslationsEn from '../search-suggester/en.translations.json.js';
import searchSuggesterTranslationsDe from '../search-suggester/de.translations.json.js';
import searchSuggesterTranslationsEs from '../search-suggester/es.translations.json.js';
import searchSuggesterTranslationsFr from '../search-suggester/fr.translations.json.js';
import searchSuggesterTranslationsIt from '../search-suggester/it.translations.json.js';
import searchSuggesterTranslationsNl from '../search-suggester/nl.translations.json.js';
import localizationSupportTranslationsEn from '../../mixins/localization-support/en.translations.json.js';
import localizationSupportTranslationsDe from '../../mixins/localization-support/de.translations.json.js';
import localizationSupportTranslationsFr from '../../mixins/localization-support/fr.translations.json.js';
import localizationSupportTranslationsIt from '../../mixins/localization-support/it.translations.json.js';
import localizationSupportTranslationsEs from '../../mixins/localization-support/es.translations.json.js';
import localizationSupportTranslationsNl from '../../mixins/localization-support/nl.translations.json.js';
import { watchlistSelectorTranslationsDe, watchlistSelectorTranslationsEn, watchlistSelectorTranslationsEs, watchlistSelectorTranslationsFr, watchlistSelectorTranslationsIt, watchlistSelectorTranslationsNl } from '../watchlist-selector/index.js';
import { marketSelectorTranslationsDe, marketSelectorTranslationsEn, marketSelectorTranslationsEs, marketSelectorTranslationsFr, marketSelectorTranslationsIt, marketSelectorTranslationsNl } from '../market-selector/index.js';
import { uiAssetClassBadgeTranslationsDe, uiAssetClassBadgeTranslationsEn, uiAssetClassBadgeTranslationsEs, uiAssetClassBadgeTranslationsFr, uiAssetClassBadgeTranslationsIt, uiAssetClassBadgeTranslationsNl } from '../ui-asset-class-badge/index.js';

const watchlistPositionAddTranslationsDe = {
  ...searchSuggesterTranslationsDe,
  ...de,
  ...marketSelectorTranslationsDe,
  ...localizationSupportTranslationsDe,
  ...watchlistSelectorTranslationsDe,
  ...uiAssetClassBadgeTranslationsDe
};
const watchlistPositionAddTranslationsEn = {
  ...searchSuggesterTranslationsEn,
  ...en,
  ...marketSelectorTranslationsEn,
  ...localizationSupportTranslationsEn,
  ...watchlistSelectorTranslationsEn,
  ...uiAssetClassBadgeTranslationsEn
};
const watchlistPositionAddTranslationsEs = {
  ...searchSuggesterTranslationsEs,
  ...es,
  ...marketSelectorTranslationsEs,
  ...localizationSupportTranslationsEs,
  ...watchlistSelectorTranslationsEs,
  ...uiAssetClassBadgeTranslationsEs
};
const watchlistPositionAddTranslationsFr = {
  ...searchSuggesterTranslationsFr,
  ...fr,
  ...marketSelectorTranslationsFr,
  ...localizationSupportTranslationsFr,
  ...watchlistSelectorTranslationsFr,
  ...uiAssetClassBadgeTranslationsFr
};
const watchlistPositionAddTranslationsIt = {
  ...searchSuggesterTranslationsIt,
  ...it,
  ...marketSelectorTranslationsIt,
  ...localizationSupportTranslationsIt,
  ...watchlistSelectorTranslationsIt,
  ...uiAssetClassBadgeTranslationsIt
};
const watchlistPositionAddTranslationsNl = {
  ...searchSuggesterTranslationsNl,
  ...nl,
  ...marketSelectorTranslationsNl,
  ...localizationSupportTranslationsNl,
  ...watchlistSelectorTranslationsNl,
  ...uiAssetClassBadgeTranslationsNl
};
const watchlistPositionAddTranslationsBundle = {
  de: watchlistPositionAddTranslationsDe,
  en: watchlistPositionAddTranslationsEn,
  es: watchlistPositionAddTranslationsEs,
  fr: watchlistPositionAddTranslationsFr,
  it: watchlistPositionAddTranslationsIt,
  nl: watchlistPositionAddTranslationsNl
};

export { watchlistPositionAddTranslationsBundle, watchlistPositionAddTranslationsDe, watchlistPositionAddTranslationsEn, watchlistPositionAddTranslationsEs, watchlistPositionAddTranslationsFr, watchlistPositionAddTranslationsIt, watchlistPositionAddTranslationsNl };
